<div class="report-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-notification">Get Speciality Report</h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="getReportForm"
      (ngSubmit)="onGetReportSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-control-label" for="report-period">
              Select Date Range
            </label>
            <input
                type="text"
                id="report-period"
                class="form-control"
                formControlName="reportPeriod"
                bsDaterangepicker
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
              />
            <div
              *ngIf="
                (isSubmited ||
                  getReportForm.controls.reportPeriod.dirty) &&
                getReportForm.controls.reportPeriod.errors
              "
              class="input-errors"
            >
              <p
                *ngIf="
                  getReportForm.controls.notificationTitle.errors
                    .required
                "
              >
                This field is required!
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            class="btn btn-block btn-primary"
            type="submit"
            [disabled]="getReportForm.invalid"
          >
            Get Report
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
